import {
  isVinylMusicDelivery,
  playUiClick,
  toggleVinylMusic,
} from '../../assets/preloadSounds';
import type { SuccessDeliveryScreenModel } from './SuccessDeliveryScreenModelScreen';

export class SuccessDeliveryScreenController {
  constructor(private readonly model: SuccessDeliveryScreenModel) {}

  handleViewResults = () => {
    playUiClick();
    this.model.onViewResults?.();
  };

  handleToggleVinylMusic = () => {
    if (!isVinylMusicDelivery(this.model.giantId, this.model.orderIndex)) {
      return;
    }
    toggleVinylMusic();
  };
}
